module.exports = __webpack_public_path__ + "media/images/logo/fb-d8620386b9a33a3f0555c3b9b04877f8.svg";